import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ENVIRONMENT } from '../environments/environment';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs';
import { LoaderService } from './services/loader.service';
import { Loader } from './shared/loader/loader';
import { ToastModule } from 'primeng/toast';

declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Loader, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  loader = inject(LoaderService);
  protected title = 'showlab-web';
  apiUrl: string;

  constructor(private router: Router, private viewportScroller: ViewportScroller) {
    this.apiUrl = ENVIRONMENT.baseUrls.baseAPIUrl;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.viewportScroller.scrollToPosition([0, 0]);
        this.toggleCrispChat(event.urlAfterRedirects);
      });
  }

  private toggleCrispChat(url: string): void {
    if (typeof window === 'undefined') {
      return;
    }
    const isMarketingEmbed = url.includes('/marketing-embed');
    document.body.classList.toggle('marketing-embed-page', isMarketingEmbed);
    if (isMarketingEmbed) {
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:hide']);
        window.$crisp.push(['do', 'chat:close']);
      }
    } else {
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:show']);
      }
    }
  }
}